import { ProtocolFactory } from 'lib/protocols';

import { EPropType } from '@types';

import { TitleProps } from './index';

export const protocolFactory = new ProtocolFactory<TitleProps>({
  name: 'Title',
  editorProps: [
    {
      type: EPropType.String,
      name: 'content',
      label: 'Content',
      required: true,
      description: 'Content of the title',
      defaultValue: 'Heading',
      allowDataLink: true,
    },
  ],
  editorConfig: {
    disableDesignSection: false,
    disableDataLinkSection: false,
    disableLogicSection: true,
  },
  themeProps: ['htmlTag', 'color', 'textStyle', 'isTruncated'],
});

export const defaultProps = protocolFactory.createDefaultProps();
